import {
  countries,
  PageTitle,
} from '@foxtrotplatform/developer-platform-common-ui-component-lib';
import React, { useEffect, FunctionComponent, useMemo } from 'react';

import { useSignUp } from '../../../common/hooks/useSignUp';
import { SignUpStep } from '../../../common/provider/SignUpContext';
import { SignUpForm } from '../types';
import { SIGN_UP_ORG_DETAIL_FORM } from '../../../common/constants';
import { SolutionType } from '../../../common/api/types';

export const Title: FunctionComponent = () => {
  const {
    currentStep,
    signUpCustomerCountry,
    errorMessage,
    selectedSolutionType,
  } = useSignUp();
  const [title, setTitle] = React.useState<string>();

  const countryName = useMemo(() => {
    return countries.find((c) => c.code === signUpCustomerCountry)?.name;
  }, [signUpCustomerCountry]);
  const companyName = useMemo(() => {
    const rawData = sessionStorage.getItem(SIGN_UP_ORG_DETAIL_FORM);
    if (rawData) {
      const dataObject: SignUpForm = JSON.parse(rawData);
      return dataObject.companyName;
    }
    return '';
  }, []);
  useEffect(() => {
    switch (currentStep) {
      case SignUpStep.settingUp:
        setTitle("Hang tight, we're creating your account.");
        break;
      case SignUpStep.waitlisted:
        setTitle(`Support for ${countryName} is coming soon`);
        break;
      case SignUpStep.contactAdmin:
        setTitle(`${companyName} is an existing organization`);
        break;
      case SignUpStep.setupFailed:
        setTitle("We're currently processing your request.");
        break;
      case SignUpStep.setupSuccess:
        if (selectedSolutionType === SolutionType.API) {
          setTitle('Welcome to OS1');
        } else {
          setTitle('Your account has been created!');
        }
        break;
    }
  }, [
    currentStep,
    countryName,
    errorMessage,
    companyName,
    selectedSolutionType,
  ]);

  return (
    <div className="w-full">
      <PageTitle className="pb-2">
        <span
          className="text-3xl font-thin text-primary-800 font-bold"
          data-testid={`${currentStep}-step-title`}
        >
          {title}
        </span>
      </PageTitle>
    </div>
  );
};
